import { useState, useCallback, useEffect } from "react";
import { useAnalytics } from "../../providers/AnalyticsProvider";
import AITelemetryDashboard from "./AITelemetryDashboard";

const BriefcaseAILanding = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const analytics = useAnalytics();

  const toggleMobileMenu = useCallback(() => {
    setMobileMenuOpen(prev => !prev);
    analytics.trackUserAction('toggle_mobile_menu', 'landing_page_navbar');
  }, [analytics]);

  const closeMobileMenu = useCallback(() => {
    setMobileMenuOpen(false);
  }, []);

  // Handle responsive design with JavaScript instead of CSS media queries
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      // Close mobile menu when switching to desktop view
      if (!mobile && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };

    // Check initial size
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener
    return () => window.removeEventListener('resize', handleResize);
  }, [mobileMenuOpen]);

  // Track page view when component mounts
  useEffect(() => {
    analytics.trackPageView('AI_Telemetry_Landing_Page', {
      page_type: 'landing',
      section: 'home'
    });
  }, [analytics]);

  return (
    <div style={{
      minHeight: "100vh",
      background: "radial-gradient(ellipse at top, #1e293b 0%, #0f172a 50%, #020617 100%)",
      color: "white",
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      {/* Navigation Header */}
      <header style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        backdropFilter: "blur(16px)",
        backgroundColor: "rgba(30, 41, 59, 0.8)",
        borderBottom: "1px solid rgba(71, 85, 105, 0.3)"
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 16px"
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "64px"
          }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                <div style={{
                  height: "32px",
                  width: "32px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  🎯
                </div>
                <a href="/" style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  textDecoration: "none",
                  color: "inherit",
                  display: "flex",
                  flexDirection: "column",
                  lineHeight: "1.1"
                }} onClick={() => analytics.trackUserAction('click_logo', 'landing_page_navbar')}>
                  <span>BriefcaseAI</span>
                  <span style={{ fontSize: "14px", fontWeight: "normal", opacity: "0.8" }}>Telemetry Dashboard</span>
                </a>
              </div>
              <nav style={{
                display: isMobile ? "none" : "flex",
                marginLeft: "40px",
                gap: "24px"
              }}>
                <a href="https://briefcasebrain.com" style={{
                  color: "rgb(148, 163, 184)",
                  textDecoration: "none",
                  transition: "color 0.3s"
                }} onClick={() => analytics.trackUserAction('click_nav_briefcase_home', 'landing_page_navbar')}>Briefcase Home</a>
                <a href="#features" style={{
                  color: "rgb(148, 163, 184)",
                  textDecoration: "none",
                  transition: "color 0.3s"
                }} onClick={() => analytics.trackUserAction('click_nav_features', 'landing_page_navbar')}>Features</a>
                <a href="https://docs.briefcasebrain.com" style={{
                  color: "rgb(148, 163, 184)",
                  textDecoration: "none",
                  transition: "color 0.3s"
                }} onClick={() => analytics.trackUserAction('click_nav_docs', 'landing_page_navbar')}>Docs</a>
              </nav>
            </div>

            <div style={{
              display: isMobile ? "none" : "flex",
              alignItems: "center",
              gap: "16px"
            }}>
              <a href="/login" style={{
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                color: "rgb(148, 163, 184)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                transition: "color 0.3s",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center"
              }} onClick={() => analytics.trackUserAction('click_login', 'landing_page_navbar')}>Login</a>
              <button style={{
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                borderRadius: "6px",
                background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                border: "none",
                color: "white",
                cursor: "pointer",
                transition: "all 0.3s",
                transform: "scale(1)"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
              }}
              onClick={() => analytics.trackUserAction('click_signup', 'landing_page_navbar')}
              >Sign Up</button>
            </div>

            <div style={{
              display: isMobile ? "block" : "none"
            }}>
              <button
                onClick={toggleMobileMenu}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px",
                  borderRadius: "6px",
                  color: "rgb(148, 163, 184)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer"
                }}
              >
                {mobileMenuOpen ? "✕" : "☰"}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && isMobile && (
          <div style={{
            display: "block",
            backdropFilter: "blur(24px)",
            backgroundColor: "rgba(30, 41, 59, 0.95)",
            borderBottom: "1px solid rgba(71, 85, 105, 0.3)"
          }}>
            <div style={{
              padding: "8px 8px 12px",
              display: "flex",
              flexDirection: "column",
              gap: "4px"
            }}>
              <a href="https://briefcasebrain.com" style={{
                display: "block",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "500",
                color: "rgb(148, 163, 184)",
                textDecoration: "none"
              }} onClick={() => {
                analytics.trackUserAction('click_nav_briefcase_home_mobile', 'landing_page_mobile_menu');
                closeMobileMenu();
              }}>Briefcase Home</a>
              <a href="#features" style={{
                display: "block",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "500",
                color: "rgb(148, 163, 184)",
                textDecoration: "none"
              }} onClick={() => {
                analytics.trackUserAction('click_nav_features_mobile', 'landing_page_mobile_menu');
                closeMobileMenu();
              }}>Features</a>
              <a href="https://docs.briefcasebrain.com" style={{
                display: "block",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "500",
                color: "rgb(148, 163, 184)",
                textDecoration: "none"
              }} onClick={() => {
                analytics.trackUserAction('click_nav_docs_mobile', 'landing_page_mobile_menu');
                closeMobileMenu();
              }}>Docs</a>
              <a href="/login" style={{
                display: "block",
                padding: "12px",
                fontSize: "16px",
                fontWeight: "500",
                color: "rgb(148, 163, 184)",
                textDecoration: "none"
              }} onClick={() => {
                analytics.trackUserAction('click_login_mobile', 'landing_page_mobile_menu');
                closeMobileMenu();
              }}>Login</a>
              <button style={{
                width: "100%",
                marginTop: "8px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                borderRadius: "6px",
                background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                border: "none",
                color: "white",
                cursor: "pointer"
              }} onClick={() => {
                analytics.trackUserAction('click_signup_mobile', 'landing_page_mobile_menu');
                closeMobileMenu();
              }}>Sign Up</button>
            </div>
          </div>
        )}
      </header>

      <main>
        {/* Hero Section */}
        <section style={{
          position: "relative",
          padding: "80px 0 128px",
          overflow: "hidden"
        }}>
          <div style={{
            position: "absolute",
            inset: 0,
            background: "#020617"
          }}>
            <div style={{
              position: "absolute",
              inset: 0,
              background: "radial-gradient(circle at 50% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 70%)"
            }} />
            <div style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "50%",
              background: "linear-gradient(to top, #020617 0%, transparent 100%)"
            }} />
            <div style={{
              position: "absolute",
              top: "25%",
              left: "25%",
              width: "256px",
              height: "256px",
              background: "rgba(139, 92, 246, 0.2)",
              borderRadius: "50%",
              filter: "blur(48px)"
            }} />
            <div style={{
              position: "absolute",
              top: "33%",
              right: "25%",
              width: "320px",
              height: "320px",
              background: "rgba(59, 130, 246, 0.2)",
              borderRadius: "50%",
              filter: "blur(48px)"
            }} />
          </div>

          <div style={{
            position: "relative",
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px",
            textAlign: "center"
          }}>
            <h1 style={{
              fontSize: "clamp(2.5rem, 5vw, 4rem)",
              fontWeight: "bold",
              marginBottom: "24px",
              lineHeight: "1.1"
            }}>
              <span style={{
                background: "linear-gradient(135deg, #60a5fa 0%, #a855f7 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
                color: "transparent"
              }}>
                AI Telemetry Dashboard
              </span>
            </h1>
            <p style={{
              fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
              color: "rgb(148, 163, 184)",
              maxWidth: "768px",
              margin: "0 auto 40px",
              lineHeight: "1.6"
            }}>
              Measure, optimize, and deploy AI systems with comprehensive telemetry analytics.
              Track impact, manage data topology, and ensure reliable performance monitoring.
            </p>
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              "@media (min-width: 640px)": {
                flexDirection: "row"
              }
            }}>
              <a href="https://calendar.app.google/J4CtczAB3HNNNBqo8" style={{
                width: "100%",
                maxWidth: "200px",
                padding: "12px 32px",
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "6px",
                background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                border: "none",
                color: "white",
                cursor: "pointer",
                transition: "all 0.3s",
                transform: "scale(1)",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                "@media (min-width: 640px)": {
                  width: "auto"
                }
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
              }}
              onClick={() => analytics.trackUserAction('click_get_started_hero', 'landing_page_hero')}
              >Get Started Free</a>
              <a href="https://briefcasebrain.com/dashboard-demo" style={{
                width: "100%",
                maxWidth: "200px",
                padding: "12px 32px",
                fontSize: "16px",
                fontWeight: "500",
                borderRadius: "6px",
                border: "1px solid rgb(71, 85, 105)",
                background: "rgba(30, 41, 59, 0.5)",
                backdropFilter: "blur(8px)",
                color: "white",
                cursor: "pointer",
                transition: "all 0.3s",
                transform: "scale(1)",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                "@media (min-width: 640px)": {
                  width: "auto"
                }
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.borderColor = "rgb(100, 116, 139)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.borderColor = "rgb(71, 85, 105)";
              }}
              onClick={() => analytics.trackUserAction('click_view_demo_hero', 'landing_page_hero')}
              >View Live Demo</a>
            </div>
          </div>
        </section>

        {/* Core Features Section */}
        <section id="features" style={{
          padding: "80px 0",
          background: "rgb(30, 41, 59)"
        }} onLoad={() => analytics.trackPageView('landing_page_features_section', { section: 'features' })}>
          <div style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px"
          }}>
            <div style={{
              textAlign: "center",
              marginBottom: "64px"
            }}>
              <h2 style={{
                fontSize: "clamp(1.875rem, 4vw, 2.5rem)",
                fontWeight: "bold",
                marginBottom: "16px"
              }}>
                Powerful AI Telemetry Features
              </h2>
              <p style={{
                fontSize: "clamp(1rem, 2vw, 1.25rem)",
                color: "rgb(148, 163, 184)",
                maxWidth: "768px",
                margin: "0 auto"
              }}>
                Everything you need to monitor, optimize, and secure your enterprise AI systems
              </p>
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "32px"
            }}>
              {/* Feature Card 1 */}
              <div style={{
                position: "relative",
                padding: "24px",
                borderRadius: "12px",
                backdropFilter: "blur(8px)",
                background: "rgba(30, 41, 59, 0.5)",
                border: "1px solid rgba(59, 130, 246, 0.2)",
                transition: "all 0.3s",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = "rgba(59, 130, 246, 0.5)";
                e.target.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = "rgba(59, 130, 246, 0.2)";
                e.target.style.transform = "translateY(0)";
              }}
              onClick={() => analytics.trackFeatureUsage('performance_monitoring', { section: 'landing_page_features' })}>
                <div style={{
                  position: "absolute",
                  top: "-16px",
                  left: "-16px",
                  height: "48px",
                  width: "48px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)"
                }}>
                  📊
                </div>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginTop: "24px",
                  marginBottom: "12px"
                }}>Measure & Monitor</h3>
                <p style={{
                  color: "rgb(148, 163, 184)",
                  marginBottom: "16px"
                }}>
                  Real-time system overview, performance metrics, and comprehensive monitoring for your AI infrastructure.
                </p>
                <ul style={{
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px"
                }}>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#60a5fa",
                      marginRight: "8px"
                    }}>▶</span>
                    System overview & health monitoring
                  </li>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#60a5fa",
                      marginRight: "8px"
                    }}>▶</span>
                    Performance metrics & analytics
                  </li>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#60a5fa",
                      marginRight: "8px"
                    }}>▶</span>
                    Impact tracking & reporting
                  </li>
                </ul>
              </div>

              {/* Feature Card 2 */}
              <div style={{
                position: "relative",
                padding: "24px",
                borderRadius: "12px",
                backdropFilter: "blur(8px)",
                background: "rgba(30, 41, 59, 0.5)",
                border: "1px solid rgba(139, 92, 246, 0.2)",
                transition: "all 0.3s",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = "rgba(139, 92, 246, 0.5)";
                e.target.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = "rgba(139, 92, 246, 0.2)";
                e.target.style.transform = "translateY(0)";
              }}
              onClick={() => analytics.trackFeatureUsage('performance_optimization', { section: 'landing_page_features' })}>
                <div style={{
                  position: "absolute",
                  top: "-16px",
                  left: "-16px",
                  height: "48px",
                  width: "48px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(139, 92, 246, 0.3)"
                }}>
                  ⚡
                </div>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginTop: "24px",
                  marginBottom: "12px"
                }}>Optimize & Deploy</h3>
                <p style={{
                  color: "rgb(148, 163, 184)",
                  marginBottom: "16px"
                }}>
                  Intelligent optimization recommendations, automated deployment workflows, and topology management for efficient operations.
                </p>
                <ul style={{
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px"
                }}>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#a78bfa",
                      marginRight: "8px"
                    }}>▶</span>
                    Performance optimization recommendations
                  </li>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#a78bfa",
                      marginRight: "8px"
                    }}>▶</span>
                    Automated deployment workflows
                  </li>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#a78bfa",
                      marginRight: "8px"
                    }}>▶</span>
                    Topology optimization
                  </li>
                </ul>
              </div>

              {/* Feature Card 3 */}
              <div style={{
                position: "relative",
                padding: "24px",
                borderRadius: "12px",
                backdropFilter: "blur(8px)",
                background: "rgba(30, 41, 59, 0.5)",
                border: "1px solid rgba(239, 68, 68, 0.2)",
                transition: "all 0.3s",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = "rgba(239, 68, 68, 0.5)";
                e.target.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = "rgba(239, 68, 68, 0.2)";
                e.target.style.transform = "translateY(0)";
              }}
              onClick={() => analytics.trackFeatureUsage('security_compliance', { section: 'landing_page_features' })}>
                <div style={{
                  position: "absolute",
                  top: "-16px",
                  left: "-16px",
                  height: "48px",
                  width: "48px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)"
                }}>
                  🛡️
                </div>
                <h3 style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginTop: "24px",
                  marginBottom: "12px"
                }}>Data Management</h3>
                <p style={{
                  color: "rgb(148, 163, 184)",
                  marginBottom: "16px"
                }}>
                  Advanced data versioning with LakeFS, user management, security controls, and comprehensive administrative tools.
                </p>
                <ul style={{
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px"
                }}>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#f87171",
                      marginRight: "8px"
                    }}>▶</span>
                    LakeFS data versioning
                  </li>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#f87171",
                      marginRight: "8px"
                    }}>▶</span>
                    User & access management
                  </li>
                  <li style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "rgb(148, 163, 184)"
                  }}>
                    <span style={{
                      color: "#f87171",
                      marginRight: "8px"
                    }}>▶</span>
                    Security & performance monitoring
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Telemetry Platform Section */}
        <section style={{
          padding: "80px 0",
          background: "#020617"
        }}>
          <div style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px"
          }}>
            <div style={{
              marginBottom: "48px",
              textAlign: "center"
            }}>
              <span style={{
                display: "inline-block",
                padding: "4px 12px",
                fontSize: "12px",
                fontWeight: "500",
                borderRadius: "9999px",
                background: "rgba(30, 58, 138, 0.3)",
                color: "#60a5fa",
                marginBottom: "16px"
              }}>
                COMPREHENSIVE PLATFORM
              </span>
              <h2 style={{
                fontSize: "clamp(1.875rem, 4vw, 2.5rem)",
                fontWeight: "bold",
                marginBottom: "16px"
              }}>
                <span style={{
                  background: "linear-gradient(135deg, #60a5fa 0%, #a855f7 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  color: "transparent"
                }}>
                  Complete Telemetry Platform for AI
                </span>
              </h2>
              <p style={{
                fontSize: "18px",
                color: "rgb(148, 163, 184)",
                maxWidth: "768px",
                margin: "0 auto"
              }}>
                Monitor every aspect of your AI systems with our comprehensive telemetry dashboard
              </p>
            </div>

            <div style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "48px",
              alignItems: "center",
              "@media (min-width: 1024px)": {
                gridTemplateColumns: "1fr 1fr"
              }
            }}>
              {/* Dashboard Component */}
              <div style={{ position: "relative" }}>
                <AITelemetryDashboard
                  animationSpeed={1}
                  showAlerts={true}
                  dataRefreshRate={3}
                />

                {/* Decorative elements */}
                <div style={{
                  position: "absolute",
                  bottom: "-24px",
                  right: "-24px",
                  height: "96px",
                  width: "96px",
                  background: "rgba(59, 130, 246, 0.2)",
                  borderRadius: "50%",
                  filter: "blur(24px)"
                }} />
                <div style={{
                  position: "absolute",
                  top: "-24px",
                  left: "-24px",
                  height: "96px",
                  width: "96px",
                  background: "rgba(139, 92, 246, 0.2)",
                  borderRadius: "50%",
                  filter: "blur(24px)"
                }} />
              </div>

              {/* Feature Details */}
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "32px"
              }}>
                <div>
                  <h3 style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    marginBottom: "12px"
                  }}>Comprehensive Monitoring</h3>
                  <p style={{
                    color: "rgb(148, 163, 184)",
                    lineHeight: "1.6"
                  }}>
                    Track every aspect of your AI systems, from model performance to infrastructure metrics.
                    Get a holistic view of your entire AI stack in one unified dashboard.
                  </p>
                </div>

                <div>
                  <h3 style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    marginBottom: "12px"
                  }}>Intelligent Alerts</h3>
                  <p style={{
                    color: "rgb(148, 163, 184)",
                    lineHeight: "1.6"
                  }}>
                    Set up custom alerts with intelligent thresholds that adapt to your system's behavior.
                    Get notified about issues before they impact your users.
                  </p>
                </div>

                <div>
                  <h3 style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    marginBottom: "12px"
                  }}>Advanced Analytics</h3>
                  <p style={{
                    color: "rgb(148, 163, 184)",
                    lineHeight: "1.6"
                  }}>
                    Dive deep into your telemetry data with advanced analytics tools.
                    Identify patterns, correlations, and anomalies to optimize your AI systems.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </section>

        {/* Strong CTA Section */}
        <section style={{
          padding: "80px 0",
          background: "linear-gradient(to bottom, rgb(30, 41, 59) 0%, #020617 100%)"
        }}>
          <div style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 16px"
          }}>
            <div style={{
              maxWidth: "768px",
              margin: "0 auto",
              textAlign: "center"
            }}>
              <h2 style={{
                fontSize: "clamp(1.875rem, 4vw, 2.5rem)",
                fontWeight: "bold",
                marginBottom: "24px"
              }}>
                Ready to{" "}
                <span style={{
                  background: "linear-gradient(135deg, #60a5fa 0%, #a855f7 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  color: "transparent"
                }}>
                  Optimize
                </span>
                {" "}Your AI Performance?
              </h2>
              <p style={{
                fontSize: "18px",
                color: "rgb(148, 163, 184)",
                marginBottom: "32px",
                lineHeight: "1.6"
              }}>
                Join teams who trust Briefcase AI for telemetry and reliability.
              </p>

              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
                marginBottom: "32px",
                "@media (min-width: 640px)": {
                  flexDirection: "row"
                }
              }}>
                <a href="https://calendar.app.google/J4CtczAB3HNNNBqo8" style={{
                  width: "100%",
                  maxWidth: "200px",
                  padding: "12px 32px",
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                  border: "none",
                  color: "white",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  transform: "scale(1)",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "@media (min-width: 640px)": {
                    width: "auto"
                  }
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                }}
                onClick={() => analytics.trackConversion('start_free_trial', { source: 'landing_page_cta' })}
                >Start Free Trial</a>
                <a href="https://docs.briefcasebrain.com" style={{
                  width: "100%",
                  maxWidth: "200px",
                  padding: "12px 32px",
                  fontSize: "16px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  border: "1px solid rgb(71, 85, 105)",
                  background: "rgba(30, 41, 59, 0.5)",
                  backdropFilter: "blur(8px)",
                  color: "white",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  transform: "scale(1)",
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "@media (min-width: 640px)": {
                    width: "auto"
                  }
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.borderColor = "rgb(100, 116, 139)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.borderColor = "rgb(71, 85, 105)";
                }}
                onClick={() => analytics.trackUserAction('click_view_documentation', 'landing_page_cta')}
                >View Documentation</a>
              </div>

              <p style={{
                fontSize: "14px",
                color: "rgb(100, 116, 139)"
              }}>
                Free 14-day trial • No setup fees • Enterprise support available
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer style={{
        background: "#020617",
        borderTop: "1px solid rgb(71, 85, 105)",
        paddingTop: "48px",
        paddingBottom: "24px"
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 16px"
        }}>
          <div style={{
            textAlign: "center",
            paddingTop: "24px"
          }}>
            <p style={{
              fontSize: "14px",
              color: "rgb(100, 116, 139)",
              margin: 0
            }}>
              © 2025 Briefcase AI. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BriefcaseAILanding;
export { BriefcaseAILanding as ModernLandingPage };